export const LOCAL_DEV_PORT = 9999;
export const API_BASE_PATH = '/api';
export const APP_BASE_PATH = '/';
